<template>
  <div>
    <table
      border="0"
      cellspacing="0"
      cellpadding="0"
    >
      <tr>
        <th>支出项目</th>
        <th>货币</th>
        <th>支出金额</th>
        <th v-if="!readOnly">
          操作
        </th>
      </tr>
      <tr
        v-for="(item, index) in form.listDailyOut"
        :key="index"
      >
        <td>
          <van-field
            v-model="item.outProductName"
            class="nopadding"
            :readonly="readOnly"
          />
        </td>
        <td v-if="readOnly">
          {{ item.currency | currencyFilter }}
        </td>
        <td
          v-else
          @click="showPopup(item, index)"
        >
          {{ item.currency | currencyFilter }}
        </td>
        <td>
          <van-field
            v-model="item.outlayMoney"
            class="nopadding"
            type="number"
            :readonly="readOnly"
          />
        </td>
        <td
          v-if="!readOnly"
          class="no-padding"
        >
          <van-button
            v-if="index === form.listDailyOut.length - 1"
            icon="add-o"
            type="info"
            size="mini"
            @click="handleDailyOutAdd"
          >
            新增
          </van-button>
          <van-button
            v-else
            icon="close"
            type="danger"
            size="mini"
            @click="handleDailyOutDel(index)"
          >
            删除
          </van-button>
        </td>
      </tr>
    </table>
    <van-popup
      v-model="currencyPopup"
      position="bottom"
      :style="{ height: '30%' }"
    >
      <van-picker
        show-toolbar
        title="货币"
        :columns="currency"
        :default-index="defaultIndex"
        @cancel="currencyPopup = false"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>
<script>
export default {
  name: "Expend",
  filters: {
    currencyFilter(val){
      if(!val)return ''
      if(val == 1)return '欧元'
      if(val == 3)return '饭票'
      return ''
    }
  },
  props: {
    form: {
      type: Object,
      default: () => {
        return {}
      }
    },
    detail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      idx: '',
      defaultIndex: '',
      currencyPopup: false,
      supCurrency: '',
      currency: [
        {value: '1', text: '欧元'}
      ]
    };
  },
  computed: {
    readOnly(){
      if(this.detail || this.form.status > 1) return true
      return false 
    }
  },
  created(){
    this.supCurrency = JSON.parse(localStorage.getItem("sushiWechatShopInfo")).supCurrency;
    if(this.supCurrency.indexOf('3')>-1){
      this.$set(this.currency, 1, {value: '3', text: '饭票'})
    }
  },
  methods: {
    handleDailyOutAdd(){
      this.form.listDailyOut.push({
        outProductName: "",
        currency: "1",
        outlayMoney: ""
      })
    },
    handleDailyOutDel(index){
      this.form.listDailyOut.splice(index, 1)
    },
    showPopup(item, index){
      this.currency.forEach((subItem, index) => {
        if(subItem.value == item.currency){
          this.defaultIndex = index
        }
      })
      this.idx = index;
      this.currencyPopup = true;

    },
    onConfirm(picker){
      this.$set(this.form.listDailyOut[this.idx], 'currency', picker.value)
      this.currencyPopup = false;
    }
  }
};
</script>
<style lang="scss" scoped>
$border-color: #f2f2f2;
.nopadding{
  padding: 0!important;
}
table {
  width: 100%;
  border-left: 2px solid $border-color;
  border-top: 2px solid $border-color;
  th,
  td {
    border-right: 2px solid $border-color;
    border-bottom: 2px solid $border-color;
    padding: 20px;
    vertical-align: middle;
    text-align: center;
  }
  th {
    font-size: 32px;
    font-weight: normal;
    background: rgba(209, 232, 255, 1);
    color: #666;
    white-space: nowrap;
  }
  td.no-padding {
    padding: 0;
  }
  td {
    font-size: 24px;
    white-space: nowrap;
  }
}
</style>

